import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeThree/appInstallBg.png'


const _hoisted_1 = { class: "panel_container" }
const _hoisted_2 = { class: "downloadTitle" }
const _hoisted_3 = { class: "downloadText" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "applicationText" }
const _hoisted_6 = { class: "download_btn" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "applicationText" }

import { goToLink } from '@/view/home/supportScript';
import { onMounted, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'downloadPanel',
  props: {
    itemData: {}
  },
  setup(__props: any) {

const iosData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const androidData = ref({
    url: "",
    redirect_url: "",
    display: false,
    text: "",
})
const customStyle = ref({
    color: ""
})
const props = __props

onMounted(() => {
    iosData.value.url = props.itemData.ios.url
    iosData.value.display = props.itemData.ios.display
    iosData.value.redirect_url = props.itemData.ios.redirect_url
    iosData.value.text = props.itemData.ios.text

    androidData.value.url = props.itemData.android.url
    androidData.value.display = props.itemData.android.display
    androidData.value.redirect_url = props.itemData.android.redirect_url
    androidData.value.text = props.itemData.android.text

    customStyle.value.color = props.itemData.styles.color
})


return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("img", {
      src: _imports_0,
      alt: ""
    }, null, -1)),
    _createVNode(_component_van_row, { class: "btn_section" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('home.downloadTitle')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "24" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('home.downloadText')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "24",
          class: "btnGroup"
        }, {
          default: _withCtx(() => [
            (iosData.value.display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "download_item",
                  style: _normalizeStyle({ background: customStyle.value.color })
                }, [
                  _createVNode(_component_van_row, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goToLink)(iosData.value.redirect_url)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "10",
                        class: "btnIcon"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: iosData.value.url,
                            alt: ""
                          }, null, 8, _hoisted_4)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "14",
                        class: "textSet"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('home.application')), 1),
                          _createElementVNode("div", _hoisted_6, _toDisplayString(iosData.value.text), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 4))
              : _createCommentVNode("", true),
            (androidData.value.display)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  span: "11",
                  class: "download_item",
                  style: _normalizeStyle({ background: customStyle.value.color })
                }, [
                  _createVNode(_component_van_row, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(goToLink)(androidData.value.redirect_url)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "10",
                        class: "btnIcon"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("img", {
                            src: androidData.value.url,
                            alt: ""
                          }, null, 8, _hoisted_7)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "14",
                        class: "textSet"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('home.application')), 1),
                          _createElementVNode("div", {
                            class: "download_btn",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(goToLink)(androidData.value.redirect_url)))
                          }, _toDisplayString(androidData.value.text), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ], 4))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})